import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { InitializationData } from '../model';
import { ConfigService, Globals } from '@aiwyn/config';
import { Observable } from 'rxjs';
import { environment } from '../../environments';
import { tap } from 'rxjs/operators';
import { logEmissions, Logger, WhiteLabelService } from '@aiwyn/shared';
import { registerLicense } from '@syncfusion/ej2-base';

@Injectable({
  providedIn: 'root',
})
export class InitService {
  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService,
    private readonly globals: Globals,
    private readonly logger: Logger,
    private readonly whiteLabelService: WhiteLabelService
  ) {}

  public initializeApplication(
    url: string = `${environment.artEngineApiUrl}/api/public/v1/init`
  ): Observable<InitializationData> {
    console.log('Aiwyn tenant name = [' + this.globals.anTenant + ']');
    const headers = new HttpHeaders().set('Tenant', this.globals.anTenant);
    registerLicense(environment.syncfusionLicenseKey);

    return this.http.get<InitializationData>(url, { headers }).pipe(
      tap((initData) => {
        this.configService.applyConfigOptions(initData.configOptions);
        this.whiteLabelService.initializeWhiteLabelStyles(initData.styleTokens);
      }),
      logEmissions(this.logger, 'APP : InitService : initializeApplication')
    );
  }
}
